import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import AlertPopup from './AlertPopup';

import { updatePatAlertData } from '../../redux/slices/scheduler/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';

function AlertWidget({ data, headerData, handleReload }) {
  const dispatch = useDispatch();
  const { patAlertData } = useSelector((state) => state.appointment);

  const [reviewPromt, setReviewPromt] = useState(false);
  const [sucPrams, setSucPrams] = useState('');
  const [alertPopup, setAlertPopup] = useState(false);

  const handleAlertChange = () => {
    setAlertPopup(true);
  };

  const handleAlertDelete = (alertID) => {
    setReviewPromt(true);
    setSucPrams(alertID);
  };

  const handleAlertDeleteConfirm = async (alertId = sucPrams) => {
    try {
      const response = await post('api/patient/ProgressNote/delSpecificAlert', {
        alertId: alertId,
      });
      if (response.status === 200) {
        if (response.data.response === 'success') {
          setUiMessage('suc', 'Alert has been deleted successfully.');
          dispatch(updatePatAlertData(response.data?.getSpecificAlertData));

          setReviewPromt(false);
          handleReload();
        } else {
          setUiMessage('err', 'Deleting alert failed.');
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const formattedData = data?.alert.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
  return (
    <>
      <div className="">
        <div className="chrt-doc-sec-nm flex-sec">{formattedData}</div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">
            Added by: {data?.alert_added_by} [{data?.date_added.substr(0, 10)}]
          </span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec">
          <span className="" onClick={() => handleAlertChange()}>
            <Link className="">Change</Link>
          </span>
          <span className="red clear-right clear-left10 qhide">|</span>
          <span className="qhide" onClick={() => handleAlertDelete(data?.id)}>
            <Link className="">Delete</Link>
          </span>
        </div>
      </div>
      {alertPopup && (
        <AlertPopup
          key={data?.id}
          headerData={headerData}
          alertData={data}
          patientId={data?.patient_id}
          handleReload={handleReload}
          alertNotifyCheck={
            patAlertData?.alertActive?.active_alert_notification
          }
          close={() => setAlertPopup(false)}
        />
      )}
      {reviewPromt && (
        <ConfirmDialog
          title={`Patient alerts`}
          bodytext={`Do you really want to delete the selected alert?`}
          closeDialog={() => setReviewPromt(false)}
          successDialog={handleAlertDeleteConfirm}
          sucPrams={sucPrams}
        />
      )}
    </>
  );
}

export default AlertWidget;
